
<div class="data-container "  >
  <div *ngIf="spinner"><span [class.spinner]="spinner"></span></div>
  <div class="mainBody" *ngIf="!spinner">
    <div class="body" >
      <div class="dropdown">
        <mat-form-field class="matselect">
          <mat-select name="OptionsString" [(value)]="selectedOption" [disabled]="disableDropdown"
            placeholder="Category" (valueChange)="itemSelected($event)">
            <mat-option [value]="'PM'">PM</mat-option>
            <mat-option [value]="'OOS'">OOS</mat-option>
            <mat-option [value]="'TYRE'">TYRE</mat-option>
            <mat-option [value]="'FERRY'">FERRY</mat-option>
            <mat-option [value]="'BREAKDOWN'">BREAKDOWN</mat-option>
            <mat-option [value]="'SUBLET'">SUB-LET</mat-option>
            <mat-option [value]="'HANBACK/BUYBACK'">HANDBACK/BUYBACK</mat-option>
            <mat-option [value]="'RECALL/WARRANTY'">RECALL/WARRANTY</mat-option>
            <mat-option [value]="'OTHER'">OTHER</mat-option>
          </mat-select>
        </mat-form-field>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button  mat-mini-fab class="minifabButton">
          <mat-icon  (click)="downloadPDF()" title="Download Pdf">picture_as_pdf</mat-icon>
        </button>
        <!-- Return Icon -->
        <!-- <button mat-icon-button (click)="goBack()" routerLink="/workCompleted" matTooltip="Return" class="long-arrow-btn">
        ←
        </button> -->
        <button  mat-raised-button  color="primary"  (click)="goBack()"  routerLink="/workCompleted"  matTooltip="Go Back"  class="back-btn">
          Back
        </button>
      </div>

      <div *ngIf="selectedOption != 'PM'" class="headers">
        <label>JOB ID</label>: {{newJobObj.RepairOrderId}}
        <label>VIN</label>: {{newJobObj.VIN_NO}}
        <label>REGO</label>: {{newJobObj.REGO}}
        <label>MVA</label>: {{newJobObj.MVA}}
        <label>Model Description</label>: {{newJobObj.model}}
        <label>KMS</label>: {{newJobObj.km}}
        <label>END DATE</label>: {{newJobObj.endtime.substring(0,10)}}
      </div>
      <div *ngIf="selectedOption == 'PM'" class="headers">
        <label>JOB ID</label>: {{newJobObj.RepairOrderId}}
        <label>Service Range</label>: {{newJobObj.pm.ServiceRange}}
        <label>KMS</label>: {{newJobObj.km}}
        <label>VIN</label>: {{newJobObj.VIN_NO}}
        <label>REGO</label>: {{newJobObj.REGO}}
        <label>MVA</label>: {{newJobObj.MVA}}
        <label>Model Description</label>: {{newJobObj.model}}
        <!-- <label>Service Minutes</label>: {{newJobObj.pm.ServiceMinutes}}
        <label>Weight</label>: {{newJobObj.pm.Weight}} -->
        <label>END DATE</label>: {{newJobObj.endtime.substring(0,10)}}
      </div>
      <br>
    </div>

  </div> <br>


  <div class="container" *ngIf="showPM">
    <!-- Display PM -->
    <form>

      <mat-checkbox color='primary' name="exteriorlights" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.exteriorlights">Check exterior lights
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="instrumentalsandcontrolsoperation" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.instrumentalsandcontrolsoperation">Check instrumentals and Control operation
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="parkbrakeoperation" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.parkbrakeoperation">Inspect park brake operation and adjust if required
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="engineoil" [disabled]="disable" [(ngModel)]="newJobObj.pm.engineoil">Change
        engine oil
      </mat-checkbox><br>

      <mat-checkbox color='primary' name=" oilfilter" [disabled]="disable" [(ngModel)]="newJobObj.pm.oilfilter">Change oil filter
      </mat-checkbox>
      <span *ngIf="newJobObj.pm.oilfilter">
        &nbsp;&nbsp;<label>Oil Supplier </label>
        <mat-select placeholder="Oil SupplierName" [(ngModel)]="newJobObj.pm.oilsupplier" name="oilsupplier"
          [disabled]="disable" style="margin-left: 10px; width: 30%;">
          <mat-option *ngFor="let supplierName of oilsupplierList" [(value)]="supplierName.SupplierName">
            {{supplierName.SupplierName}}</mat-option>
          <mat-option *ngFor="let option of options" [value]="option">{{option}}</mat-option>
        </mat-select>
      </span>
      <br>

      <mat-checkbox color='primary' name="underbodyforleaks" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.underbodyforleaks">Inspect underbody for leaks, wear and tear and damage
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="tyresforweartear" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.tyresforweartear">Inspect tyres for wear/tear. Rotate where required
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="enginecompartmentforleakagewearanddamage" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.enginecompartmentforleakagewearanddamage">Inspect engine compartment for leakage, wear and damage
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="TyreDepth" [disabled]="disable" [(ngModel)]="newJobObj.pm.TyreDepth">Record tyre depth
      </mat-checkbox><br>

      <label>
        Number of tyres used </label> <input type="number" id="pmTxt" maxlength="10" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.NumberOfTyreUsed" name="NumberOfTyreUsed" />
      <br>

      <label for="LFH"> LHF </label>
      <input class="tyreboxes" type="number" id="pmTxt" name="TLFH" size="4" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.TLFH">
      <label for="LHR"> LHR </label>
      <input class="tyreboxes" type="number" id="pmTxt" name="TLHR" size="4" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.TLHR">
      <label for="RHF"> RHF </label>
      <input class="tyreboxes" type="number" id="pmTxt" name="TRHF" size="4" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.TRHF">

      <label for="RHR"> RHR </label>
      <input class="tyreboxes" type="number" id="pmTxt" name="TRHR" size="4" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.TRHR">
      <label for="SPARE"> SPARE </label>
      <input class="tyreboxes" type="number" id="pmTxt" name="TSPARE" size="4" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.TSPARE"><br>
      <div>

        <label>Select Supplier</label>

        <mat-select placeholder="SupplierName" [(ngModel)]="newJobObj.pm.supplier" name="supplier"
          (selectionChange)="applyfilter($event.value)" [disabled]="disable" style="margin-left: 10px; width: 30%;">
          <mat-option *ngFor="let supplierName of supplierList" [(value)]="supplierName.SupplierName">
            {{supplierName.SupplierName}}</mat-option>
          <mat-option *ngFor="let option of options" [value]="option">{{option}}</mat-option>
        </mat-select>

      </div>

      <div>
        <label>Select Tyre</label>

        <mat-select placeholder="TyreName" [(ngModel)]="newJobObj.pm.tyre" name="tyre" [disabled]="disable"
          style="margin-left: 10px; width: 30%;">
          <mat-option *ngFor="let tyreName of tyreList" [(value)]="tyreName.Product">{{tyreName.Product}}</mat-option>
          <!-- <mat-option *ngFor="let option of options" [value]="option" >{{option}}</mat-option> -->
        </mat-select>

      </div>
      <div *ngIf="newJobObj.pm.supplier==='Other'">
        <label>Vendor Name </label> <input class=" " id="pmTxt" type="text" [(ngModel)]="newJobObj.pm.VendorName"
          name="VendorName" [disabled]="disable" />
        <br>
        <label>Cost Of Tyre </label> <input class="" id="pmTxt" type="number" [(ngModel)]="newJobObj.pm.CostOfTyre"
          name="CostOfTyre" [disabled]="disable" />
      </div>
      <mat-checkbox color='primary' name="airfilter" [disabled]="disable" [(ngModel)]="newJobObj.pm.airfilter">Check air filter
      </mat-checkbox>
      <mat-checkbox color='primary' class="Replaced" name="AIR_FILTER_REPLACED" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.AIR_FILTER_REPLACED">Replaced
      </mat-checkbox><br>


      <mat-checkbox color='primary' name="INSP_BRAKE_PADS_DEPTH" [disabled]="disable" [(ngModel)]="newJobObj.pm.INSP_BRAKE_PADS_DEPTH">Inspect brake pads depth
      </mat-checkbox><br>


      <mat-checkbox color='primary' name="brakepadsdepth" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.brakepadsdepth">Record brake pad depth
      </mat-checkbox>
      <mat-checkbox class="Replaced" color='primary' name="BRAKE_PAD_DEPTH_REPLACED" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.BRAKE_PAD_DEPTH_REPLACED">Replaced
      </mat-checkbox><br>

      <label for="LFH"> LHF </label>
      <input class="tyreboxes" type="number" id="pmTxt" name="BLFH" size="4" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.BLFH">
      <label for="LHR"> LHR </label>
      <input class="tyreboxes" type="number" id="pmTxt" name="BLHR" size="4" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.BLHR">
      <label for="RHF"> RHF </label>
      <input class="tyreboxes" type="number" id="pmTxt" name="BRHF" size="4" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.BRHF">

      <label for="RHR"> RHR </label>
      <input class="tyreboxes" type="number" id="pmTxt" name="BRHR" size="4" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.BRHR">
      <br>

      <mat-checkbox color='primary' name="fuelfliters" [disabled]="disable" [(ngModel)]="newJobObj.pm.fuelfliters">
        Replace fuel filter as required
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="pollenfilter" [disabled]="disable" [(ngModel)]="newJobObj.pm.pollenfilter">
        Check pollen filter/clean or replace as required
      </mat-checkbox>
      <mat-checkbox color='primary' class="Replaced" name="POLLEN_FILTER_REPLACED" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.POLLEN_FILTER_REPLACED">Replaced
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="underbonnetfluids" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.underbonnetfluids">Inspect and top up all under bonnet fluids
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="recordandstampservice" [disabled]="disable"
        [(ngModel)]="newJobObj.pm.recordandstampservice">Record and stamp service book
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="checkforholds" [disabled]="disable" [(ngModel)]="newJobObj.pm.checkforholds">
        Check for any holds against the car, and remove if required
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="updatewizard" [disabled]="disable" [(ngModel)]="newJobObj.pm.updatewizard">
        Update Wizard
      </mat-checkbox><br>
      <p>
        <label for="textarea">Comments</label><br>
        <textarea rows="5" cols="30" [(ngModel)]="newJobObj.pm.Comments" name="Comments"
          [disabled]="disable"></textarea>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <button mat-button color="primary" (click)="saveComments()">Save Comment</button><br>
      </p>


      <label *ngIf="!storeConditionForDisplayclock">
        TotalDuration: <input type="text" rel="dentistry" name="totaltimeforJob" [(ngModel)]="totaltimeforJob"
          [disabled]="disable" size="8" />&nbsp;
        <a href="" onclick="return false;" id="details" [mdePopoverTriggerFor]="appPopover" mdePopoverTriggerOn="click"
          #popoverTrigger="mdePopoverTrigger"><i>Details</i></a>
      </label><br>
      <!-- Display clock on screen if storeConditionForDisplayclock=true  -->
      <a mat-mini-fab class="material-icons floating-btn" *ngIf="storeConditionForDisplayclock"
        (click)="postData()"><img [src]=watchimg class="watchimage" /></a>
      <!-- <a mat-mini-fab class="custom-button"><mat-icon>check</mat-icon></a> -->

    </form>
  </div>
  <div class="container" *ngIf="showHB">
    <!-- Display HB -->
    <form>

      <mat-checkbox color='primary' name="servicebook" [disabled]="disable"
        [(ngModel)]="newJobObj.handbackbuyback.ServeBook">Service Book
      </mat-checkbox><br>



      <mat-checkbox color='primary' name="ownersManual" [disabled]="disable"
        [(ngModel)]="newJobObj.handbackbuyback.OWNER_MAN">Owners Manual
      </mat-checkbox><br>


      <mat-checkbox color='primary' name="primarySpareKey" [disabled]="disable"
        [(ngModel)]="newJobObj.handbackbuyback.PRIMARY_AND_SPARE">Primary and Spare Key
      </mat-checkbox><br>


      <mat-checkbox color='primary' name="ToolsWheelbrace" [disabled]="disable"
       [(ngModel)]="newJobObj.handbackbuyback.TOOLS_BRACE_JACK">
        Tools being wheel brace and jack
      </mat-checkbox><br>


      <mat-checkbox color='primary' name=" SDCard" [disabled]="disable" [(ngModel)]="newJobObj.handbackbuyback.SD_CARD">
        SD card
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="OtherAccessories" [disabled]="disable"
        [(ngModel)]="newJobObj.handbackbuyback.ANY_OTHER_ACCESSORIES">Any other accessories i.e. air compressor
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="GlassFreeofDefects" [disabled]="disable"
        [(ngModel)]="newJobObj.handbackbuyback.GLASS_FREE_DEFECTS_DRIVERS_VISION">Glass, free of defects that could impair the drivers vision
      </mat-checkbox><br>


      <mat-checkbox color='primary' name="TyresMatching" [disabled]="disable"
        [(ngModel)]="newJobObj.handbackbuyback.TYRES_MATCHING_AXLE_">
        Tyres matching on axels and comply with Roadworthy standards
      </mat-checkbox><br>


      <mat-checkbox color='primary' name="WheelRims" [disabled]="disable"
       [(ngModel)]="newJobObj.handbackbuyback.WHEEL_RIMs_SCRAP">
        Wheel Rims, with no more than 15% of scrapes and scratches
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="WheelTrims" [disabled]="disable"
       [(ngModel)]="newJobObj.handbackbuyback.WHEEL_TRIMs_SCRAP">
        Wheel Trims, with no more than 15% of scrapes and scratches
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="LightsReflectors" [disabled]="disable" 
      [(ngModel)]="newJobObj.handbackbuyback.LIGHT_REFLECTORS_STATE">
        Lights/Reflectors & Garnish, comply with Roadworthy standards for each state
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="CarpetsUpholstery" [disabled]="disable"
        [(ngModel)]="newJobObj.handbackbuyback.CARPET_RIPPED_HEEL_PADS">
        Carpets / Upholstery, Look for tears, rips, cuts, holes, burn holes, stained, mismatched colours, 
        and holes or ripped heel pads
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="Interior" [disabled]="disable"
        [(ngModel)]="newJobObj.handbackbuyback.INTERIOR_NO_MORE">Interior, no more than 3 permanent less than 15mm in diameter
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="PaintToPanel" [disabled]="disable"
        [(ngModel)]="newJobObj.handbackbuyback.PAINT_TO_PANEL">Paint to Panel per standard Fair Wear and Tear Guidelines
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="VehRegistered" [disabled]="disable" 
      [(ngModel)]="newJobObj.handbackbuyback.NZ_VEHICLE_REGISTERED">
        NZ: Vehicle Registered
      </mat-checkbox><br>

      <mat-checkbox color='primary' name="VehicleCOF" [disabled]="disable"
       [(ngModel)]="newJobObj.handbackbuyback.NZ_VEHICLE_CURRENT_COF">
        NZ: Vehicle has current COF
      </mat-checkbox><br>

      <p>
        <label for="textarea">Comments</label><br>
        <textarea rows="5" cols="30" [(ngModel)]="newJobObj.handbackbuyback.COMMENT" name="Comments"
          [disabled]="disable"></textarea>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button mat-button color="primary" (click)="saveComments()">Save Comment</button><br>
      </p>


      <label *ngIf="!storeConditionForDisplayclock">
        TotalDuration: <input type="text" rel="dentistry" name="totaltimeforJob" [(ngModel)]="totaltimeforJob"
          [disabled]="disable" size="8" />&nbsp;
        <a href="" onclick="return false;" id="details" [mdePopoverTriggerFor]="appPopover" mdePopoverTriggerOn="click"
          #popoverTrigger="mdePopoverTrigger"><i>Details</i></a>
      </label><br>
      <!-- Display clock on screen if storeConditionForDisplayclock=true  -->
      <a mat-mini-fab class="material-icons floating-btn" *ngIf="storeConditionForDisplayclock"
        (click)="postData()"><img [src]=watchimg class="watchimage" /></a>
      <!-- <a mat-mini-fab class="custom-button"><mat-icon>check</mat-icon></a> -->

    </form>
  </div>

  <!--Display SUBLET -->
  <div class="container" *ngIf="showSUBLET" style="width:102%;">
    <form>

      <table>
        <tr *ngIf="showWC === 'true'">
          <td> <label class="subletLabel"> Supplier</label></td>
          <td> <input type="text" class="sublettxtBox" name="supplier" [disabled]="disable"
              [(ngModel)]="newJobObj.sublet.supplier" /> </td>
        </tr>
        <tr *ngIf="showWIP === 'true'">
          <td><label class="subletLabel">Supplier</label></td>
          <td>
            <mat-form-field class="matselect" appearance="fill">
              
              <mat-select
                [disabled]="disable"
                [(ngModel)]="newJobObj.sublet.supplier"
                (openedChange)="onSupplierDropdown($event)"
                (selectionChange)="onSupplierSelected($event.value)"
                panelClass="supplier-select-panel">
                
                <!-- Search box at top -->
                <mat-option disabled>
                  <input
                    type="text"
                    placeholder="Search supplier..."
                    [(ngModel)]="supplierSearchText"
                    [ngModelOptions]="{standalone: true}"
                    (input)="onSupplierSearch(supplierSearchText)"
                    (click)="$event.stopPropagation()"
                    class="w-full p-1 border rounded"
                  />
                </mat-option>

                <!-- Supplier suggestions -->
                <mat-option
                  *ngFor="let supplier of filteredSuppliers"
                  [value]="supplier">
                  {{ supplier }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Add supplier inline input -->
            <div *ngIf="showAddSupplierInput" class="add-supplier-box">
              <input
                type="text"
                [(ngModel)]="newSupplierName"
                placeholder="Enter supplier name"
                class="sublettxtBox"
              />
              <button mat-button color="primary" (click)="confirmAddSupplier($event)">✔</button>
              <button mat-button color="warn" (click)="cancelAddSupplier($event)">✖</button>
            </div>
          </td>
        </tr>
        <tr>
          <td><label class="subletLabel">Cost ex gst</label></td>
          <td><input type="number" class="sublettxtBox" size="10" maxlength="10" name="cost" [disabled]="disable"
              [(ngModel)]="newJobObj.sublet.cost" />
          </td>
        </tr>
        <tr>
          <td>
            <mat-checkbox color='primary' name="executepmp" [disabled]="disable || !newJobObj.km"
              [(ngModel)]="newJobObj.sublet.executePMP">PM - Execute PMP (Preventattive Maintanance) in Fleet System
            </mat-checkbox>
          </td>
        </tr>
        <tr>
          <td> <label class="subletLabel">PO Number</label> </td>
          <td><input type="text" class="sublettxtBox" size="10" maxlength="10" name="ponumber" [disabled]="disable"
              [(ngModel)]="newJobObj.sublet.ponumber" />
          </td>
        </tr>
        <tr>
          <td> <label class="subletLabel">Invoice Number</label> </td>
          <td><input type="text" class="sublettxtBox" size="10" maxlength="10" name="invoicenumber" [disabled]="disable"
              [(ngModel)]="newJobObj.sublet.invoicenumber" />
          </td>
        </tr>
        <tr>
          <td> <label class="subletLabel">
              Kilometres </label></td>
          <td> <input type="number" class="sublettxtBox" size="10" maxlength="10" name="kilometres" [disabled]="disable"
              [(ngModel)]="newJobObj.sublet.kilometres" />
          </td>
        </tr>
        <tr>
          <td><label class="subletLabel">
              Work Carried Out</label></td>
          <td> <input type="text" class="sublettxtBox" name="workcarriedout" [disabled]="disable"
              [(ngModel)]="newJobObj.sublet.workcarriedout" />
          </td>
        </tr>
        <tr>
          <td><label class="subletLabel">
              Sublet Date</label></td>
          <td>
            <mat-form-field class="example-full-width">
              <input matInput [matDatepicker]="picker" placeholder="Choose a date" name="subletdate"
                [disabled]="disable" [(ngModel)]="subdate">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </td>
        </tr>
      </table>


      <p>
        <label for="textarea">Comments</label><br>
        <textarea rows="5" cols="30" [(ngModel)]="newJobObj.sublet.comments" name="comments"
          [disabled]="disable"></textarea>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button mat-button color="primary" (click)="saveComments()">Save Comment</button><br>
      </p>

      <label *ngIf="!storeConditionForDisplayclock">
        TotalDuration: <input type="text" rel="dentistry" name="totaltimeforJob" [(ngModel)]="totaltimeforJob"
          [disabled]="disable" size="8" />&nbsp;
        <a href="" onclick="return false;" id="details" [mdePopoverTriggerFor]="appPopover" mdePopoverTriggerOn="click"
          #popoverTrigger="mdePopoverTrigger"><i>Details</i></a>
      </label><br>
      <!-- Display clock on screen if storeConditionForDisplayclock=true  -->
      <a mat-mini-fab class="material-icons floating-btn" *ngIf="storeConditionForDisplayclock"
        (click)="postData()"><img [src]=watchimg class="watchimage" /></a>
    </form>
  </div>
  <!-- Display  TYRE-->

  <div class="container" *ngIf="showTYRE">
    <form>
      <div>

        <h3>Select Supplier</h3>
        <mat-form-field>
          <mat-select placeholder="SupplierName" [(ngModel)]="newJobObj.tyre.supplier" name="supplier"
            (selectionChange)="applyfilter($event.value)" [disabled]="disable">
            <mat-option *ngFor="let supplierName of supplierList" [(value)]="supplierName.SupplierName">
              {{supplierName.SupplierName}}</mat-option>
            <mat-option *ngFor="let option of options" [value]="option">{{option}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div>
        <h3>Select Tyre</h3>
        <mat-form-field>
          <mat-select placeholder="TyreName" [(ngModel)]="newJobObj.tyre.tyre" name="tyre" [disabled]="disable">
            <mat-option *ngFor="let tyreName of tyreList" [(value)]="tyreName.Product">{{tyreName.Product}}</mat-option>
            <!-- <mat-option *ngFor="let option of options" [value]="option" >{{option}}</mat-option> -->
          </mat-select>
        </mat-form-field>
        <br>
      </div>
      <!-- &nbsp;Other &nbsp;<input type="text" class="sublettxtBox" placeholder="Enter the Tyre" [(ngModel)]="newJobObj.tyre.other" name="other" [disabled]="disable" ><br> -->
      <div *ngIf="newJobObj.tyre.supplier==='Other'">
        <label>Vendor Name </label> <input class="sublettxtBox" id="pmTxt" type="text"
          [(ngModel)]="newJobObj.tyre.VendorName" name="VendorName" [disabled]="disable" /><br>

        <label>Cost Of Tyre </label> <input class="sublettxtBox" id="pmTxt" type="number"
          [(ngModel)]="newJobObj.tyre.CostOfTyre" name="CostOfTyre" [disabled]="disable" />
      </div>


      <label>
        Number Of Tyres Used </label> <input type="number" class="sublettxtBox" id="pmTxt" maxlength="10"
        [disabled]="disable" [(ngModel)]="newJobObj.tyre.NumberOfTyre" name="NumberOfTyre" />
      <br>

      <p>
        <label for="textarea">Comments</label><br>
        <textarea rows="5" cols="30" [(ngModel)]="newJobObj.tyre.other" name="other"
          [disabled]="disable"></textarea>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button mat-button color="primary" (click)="saveComments()">Save Comment</button><br>
      </p>



      <label *ngIf="!storeConditionForDisplayclock">
        TotalDuration: <input type="text" rel="dentistry" name="totaltimeforJob" [(ngModel)]="totaltimeforJob"
          [disabled]="disable" size="8" />&nbsp;
        <a href="" onclick="return false;" id="details" [mdePopoverTriggerFor]="appPopover" mdePopoverTriggerOn="click"
          #popoverTrigger="mdePopoverTrigger"> <i>Details</i></a>
      </label><br>
      <!-- Display clock on screen if storeConditionForDisplayclock=true  -->
      <a mat-mini-fab class="material-icons floating-btn" *ngIf="storeConditionForDisplayclock"
        (click)="postData()"><img [src]=watchimg class="watchimage" /></a>
    </form>
  </div>

  <div class="container" *ngIf="showOther">
    <form>
      <!-- &nbsp;COMMENT&nbsp;<input type="text" class="sublettxtBox" [(ngModel)]="newJobObj.other.COMMENT" name="COMMENT"  [disabled]="disable"><br> -->

        <form #commentForm="ngForm">
        <div *ngIf="newJobObj.radiobutton!='OTHER' && newJobObj.MVA!=''">
          <label for="textarea">COMMENT</label><br>
          <textarea rows="5" cols="30" [(ngModel)]="newJobObj.other.COMMENT" name="COMMENT"
          [disabled]="disable"></textarea>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button mat-button color="primary" (click)="saveComments()">Save Comment</button><br>
        </div>

        <div *ngIf="newJobObj.radiobutton=='OTHER' || newJobObj.MVA==''">
        <label for="textarea">COMMENT <span class="required">*</span><span class="err-text" *ngIf="!isCommentValid()"> &nbsp;Only words (letters and spaces) are allowed</span></label><br>
        
        <textarea 
          rows="5" 
          cols="30" 
          [(ngModel)]="newJobObj.other.COMMENT" 
          name="COMMENT"
          [disabled]="disable" 
          (input)="validateComment()"
          [ngClass]="{'invalid-input': !isCommentValid()}">
        </textarea>
        

        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <button mat-button color="primary" (click)="saveComments()" [disabled]="!isCommentValid()">Save Comment</button><br>
        </div>
        
        </form>
        

      <label *ngIf="!storeConditionForDisplayclock">
        TotalDuration: <input type="text" rel="dentistry" name="totaltimeforJob" [(ngModel)]="totaltimeforJob"
          [disabled]="disable" size="8" />&nbsp;
        <a href="" onclick="return false;" id="details" [mdePopoverTriggerFor]="appPopover" mdePopoverTriggerOn="click"
          #popoverTrigger="mdePopoverTrigger"><i>Details</i></a>
      </label><br>
      <!-- Display clock on screen if storeConditionForDisplayclock=true  -->
      <a mat-mini-fab class="material-icons floating-btn" *ngIf="storeConditionForDisplayclock"
        (click)="postData()"><img [src]=watchimg class="watchimage" /></a>
    </form>
  </div>
  <!-- <div align="right">
                <button class="floatbtn"mat-mini-fab color="warn" aria-label="Example icon button with a bookmark icon">
                    <mat-icon>av_timer</mat-icon>
                </button>
            </div > -->
</div>


<!-- </div>  -->

<mde-popover #appPopover="mdePopover" [mdePopoverOverlapTrigger]="false">
  <mat-card>
    <mat-card-content>
      <table class="table table-striped" *ngIf="timePopover">
        <thead>
          <tr>
            <th scope="col">Start time</th>
            <th scope="col">End time</th>
          </tr>
        </thead>
        <ng-container *ngIf="showTimeArray.length">
          <tbody>
            <tr *ngFor="let item of showTimeArray">
              <td>{{item.starttime2}}</td>
              <td>{{item.endtime2}}</td>
            </tr>
          </tbody>
        </ng-container>
      </table>
    </mat-card-content>
  </mat-card>
</mde-popover>